import { apiClient } from '../../gateways/api'
import type { Profile } from '../types/Profile'

export { fetchProfile }

const fetchProfile = async (): Promise<Profile> => {
  const { data } = await apiClient({
    url: '/rest/account/profile',
    method: 'GET',
  })

  return data
}
